import React from 'react';

const ReviewCardSkeleton: React.FC = () => {
    return (
        <div className="w-full min-w-[224px] xl:w-[32%] self-stretch p-3 lg:p-4 xl:p-5 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-neutral-200 inline-flex flex-col justify-start items-start gap-2.5 animate-pulse">
            <div className="self-stretch rounded-xl inline-flex justify-start items-center gap-2">
                <div className="w-6 h-6 bg-gray-200 rounded"></div>
                <div className="flex-1 h-6 bg-gray-200 rounded max-w-[120px]"></div>
            </div>

            <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-200"></div>

            <div className="self-stretch flex-1 flex flex-col justify-between items-start">
                <div className="self-stretch inline-flex justify-start items-center gap-2 mb-5">
                    <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
                    <div className="flex-1 inline-flex flex-col justify-start items-start gap-2">
                        <div className="h-4 bg-gray-200 rounded w-12"></div>
                        <div className="inline-flex justify-start items-center gap-2">
                            <div className="h-5 bg-gray-200 rounded w-8"></div>
                            <div className="h-4 bg-gray-200 rounded w-16"></div>
                        </div>
                    </div>
                </div>

                <div className="flex w-full min-h-[60px]">
                    <div className="flex flex-col w-1/2 justify-between">
                        <div className="h-4 bg-gray-200 rounded w-16 mb-2"></div>
                        <div className="h-6 bg-gray-200 rounded w-8"></div>
                    </div>
                    <div className="border-l border-[#E5E5E5] flex flex-col w-1/2 pl-4">
                        <div className="h-4 bg-gray-200 rounded w-12 mb-2 self-end"></div>
                        <div className="flex justify-between">
                            <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
                            <div className="h-6 bg-gray-200 rounded w-4"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ReviewsSkeletonLoader: React.FC = () => {
    return <ReviewCardSkeleton />;
};

export default ReviewsSkeletonLoader;
